module.exports = "table {\n  width: 100%; }\n\nth.mat-header-cell {\n  text-align: center; }\n"